const types = {
    SAVE_PARAMS: 'MEMBER/SAVE_PARAMS',
    CLEAR_PARAMS: 'member/CLEAR_PARAMS',
    CHANGE_CREATE_MODAL: 'MEMBER/CHANGE_CREATE_MODAL'
};

export const actions = {
    saveParams: params => ({
        type: types.SAVE_PARAMS,
        params,
    }),
    clearParams: () => ({
        type: types.CLEAR_PARAMS,
    }),
    changeCreateModal: (showCreateModal) => ({
        type: types.CHANGE_CREATE_MODAL,
        showCreateModal
    })
}

const initState = {
    saveParams: {},
    showCreateModal: false,
};

const memberReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_PARAMS:
            return {
                ...state,
                saveParams: {
                    ...state.saveParams,
                    ...actions.params
                }
            };
        case types.CLEAR_PARAMS:
            return {
                ...state,
                saveParams: {}
            };
        case types.CHANGE_CREATE_MODAL:
            return {
                ...state,
                showCreateModal: actions.showCreateModal
            };
        default:
            return state;
    }
}

export default memberReducer;


// WEBPACK FOOTER //
// ./src/actions/memberActions.js